import { Box } from '@mui/material';

import { DialogLayout } from '../../presentation/components/dialog-layout';
import { ConvergeNotes } from '../notes';
import { NoteTargetName, NoteTargetType } from '@converge/graphql';
import './submission-renewal-modal.scss';
interface CreateClaimModalProps {
  onClose?: () => void;
  callHandleUpdateRenewalType: () => void;

  title: string;
  subTitle?: string;
  uuid: string;
}

export const SubmissionRenewalModal = ({
  onClose,
  title,
  uuid,
  callHandleUpdateRenewalType,
}: CreateClaimModalProps) => {
  //
  return (
    <DialogLayout
      sx={{
        overflow: 'hidden',
        '& .MuiPaper-root.MuiDialog-paper': {
          maxWidth: '100px',
          minWidth: '800px',
          overflow: 'hidden !important',
          fontFamily: 'Red Hat Text, Arial, sans-serif',
        },
        '& .MuiDialogContent-root ': {
          overflow: 'hidden !important',
        },
      }}
      className="renewal-modal"
      open
      onClose={onClose}
      showCloseButton={true}
      onCloseIconClick={onClose}
      header={
        <Box className="renewal-main-title">
          {title}
          {'Add Underwriting Note'}
        </Box>
      }
    >
      <Box className="submission-renewal-content">
        Changing the current renewal type for this insured requires an
        explanation. If you do not want to update the the renewal, you can
        cancel this action.
      </Box>
      <Box style={{ margin: '0px 19px 0px 10px' }}>
        <ConvergeNotes
          onClose={onClose}
          LabelForConfirmBtn={'SAVE'}
          callHandleUpdateRenewalType={callHandleUpdateRenewalType}
          showBtn={true}
          title="Underwriting notes"
          targetName={NoteTargetName.Submission}
          targetType={NoteTargetType.Node}
          label={['renewal_notes']}
          targetUuid={uuid}
          hideHeader
          containerWidth={12}
          testId="underwriting-renewal"
          showMessage={false}
        />
      </Box>
    </DialogLayout>
  );
};
